module.exports = __webpack_public_path__ + "static/img_senior-thougthful-24e88abf48d20c07052f18937077475b.webp";